import { ReferralUrlByWaitlistUserIdDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";
import { getUrl } from "~lib";

export const useReferralLink = ({
  eventId,
  waitlistUserId,
  organizationSlug,
}: {
  eventId?: string;
  waitlistUserId: string;
  organizationSlug: string;
}) => {
  const { data: referralUrl } = useQuery(
    eventId && waitlistUserId && ReferralUrlByWaitlistUserIdDocument,
    {
      eventId,
      waitlistUserId,
    }
  );

  const link =
    referralUrl?.referralUrlByWaitlistUserId ??
    `${getUrl(organizationSlug, true)}/events/${eventId}/waitlist`;

  return link;
};
